import React, { memo } from 'react';
import { View, TouchableOpacity } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import {
  IconButton,
  IconNegative,
  IconPlus,
  Text,
} from '@redlink/components/atoms';
import { useLocale } from '@redlink/assets/locale';
import {
  modifyProductBasket,
  getProductBasketItems,
  useQuery,
} from '@redlink/services';

export const PreviewShopPostCardCountBlock = memo(({ item = {} }) => {
  const { id, isAvailable } = item;
  const { styles, colors } = useStyle();
  const { dictionary } = useLocale();

  const {
    data: { ProductBasketItems },
  } = useQuery(getProductBasketItems);

  const { count = 0 } =
    ProductBasketItems.find(({ item: product }) => product.id === id) || {};

  return (
    <View>
      <View style={styles.countBlockContainer}>
        {count > 0 && (
          <>
            <IconButton
              style={styles.countButton}
              disabled={count === 0}
              onPress={() => {
                modifyProductBasket({ item, count: count - 1 });
              }}
            >
              <IconNegative color={colors.white} />
            </IconButton>
            <Text style={styles.countText}>{count}</Text>
            <IconButton
              style={styles.countButton}
              onPress={() => {
                modifyProductBasket({ item, count: count + 1 });
              }}
            >
              <IconPlus color={colors.white} />
            </IconButton>
          </>
        )}
        {count === 0 && (
          <TouchableOpacity
            disabled={!isAvailable}
            activeOpacity={0.6}
            onPress={() => {
              modifyProductBasket({ item, count: 1 });
            }}
          >
            <Text
              style={[
                styles.addButtonText,
                isAvailable
                  ? styles.addButtonTextAvailable
                  : styles.addButtonTextNotAvailable,
              ]}
            >
              {`${isAvailable ? dictionary.addToCard : dictionary.notAvailble}`}
            </Text>
          </TouchableOpacity>
        )}
      </View>
    </View>
  );
});

const useStyle = createUseStyle(
  ({ colors, shadow, size, ltrFlexDirection }) => ({
    addButtonText: {
      fontWeight: 'bold',
      fontSize: 16,
      textAlign: 'center',
    },
    addButtonTextAvailable: {
      color: colors.primary,
    },
    addButtonTextNotAvailable: {
      color: colors.saparator,
    },
    countBlockContainer: {
      flexDirection: ltrFlexDirection,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: colors.cardBackground,
      borderRadius: 10,
      paddingHorizontal: 16,
      height: 56,
    },
    countButton: {
      width: 30,
      height: 30,
      padding: 0,
      borderRadius: 5,
      backgroundColor: colors.green1,
    },
    countText: {
      color: colors.primary,
      fontSize: 26,
      flex: 1,
      textAlign: 'center',
    },
  })
);
